import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { ENTITY } from "../constants";
import { getElementMediaItems } from "../store/actions";

export function useElementMediaItemsData(props) {
  const { propertyId, sortField, sortOrientation } = props;

  const dispatch = useDispatch();
  const timer = useRef(null);

  const fetchElementMediaItemsData = (delay = 50) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      const query = {
        sortField,
        sortOrientation,
      };

      dispatch(getElementMediaItems(propertyId, query));
    }, delay);
  };

  useEffect(() => {
    fetchElementMediaItemsData();
  }, [propertyId, sortField, sortOrientation]);

  useEffect(() => {
    const listener = () => fetchElementMediaItemsData(300);

    const entities = [ENTITY.MEDIA_ITEM, ENTITY.CONTENT_TYPE, ENTITY.MEDIA_ITEM_MEMBER];

    entities.forEach((entity) => document.addEventListener(entity, listener));
    return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
  }, [propertyId, sortField, sortOrientation]);
}
